
import { HomeActions } from './HomeActions';

const initialState = {
    statistiche: null,
}

const home = (state, action) => {

    if (typeof state === 'undefined') {
        return initialState
    }

    switch (action.type) {
        case HomeActions.STATISTICHE:
            return Object.assign({}, state, { statistiche: action.dati, })
        default:
            return state;
    }
}

export default home;